import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthConfig, AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { NZ_I18N, en_GB, provideNzI18n } from 'ng-zorro-antd/i18n';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

const authConfig: AuthConfig = {
  domain: environment.auth0.domain,
  clientId: environment.auth0.clientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: environment.auth0.audience,
    scope: environment.auth0.scope,
  },
  httpInterceptor: {
    allowedList: [
      {
        uri: `${environment.api.baseUrl}/*`,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.audience,
            scope: environment.auth0.scope,
          },
        },
      },
    ],
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(
      AuthModule.forRoot(authConfig),
      BrowserModule,
      FormsModule,
    ),
    provideNzI18n(en_GB),
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
};
